import { css } from "@emotion/react";
import { TTargetList } from "../../..";
// import trelloColors from "../../../../shared/styles/trello-colors";
// import ConditionalRender from "../../../../modal/utils/conditional-renderer";
import ExpandIcon from "../../../../../assets/expand_more-black-18dp.svg";
import { ReactElement } from "react";
import ConditionalRender from "../../../../shared/components/conditional-renderer";
import BoardTargetsSummary from "../../../board-targets-summary";
import trelloColors from "../../../../../styles/trello-colors";
// import BoardTargetsSummary from "../../../shared/board-targets-summary";

export type TCardsGroupHeaderProps = {
  boardImage?: string;
  boardColor: string;
  boardName: string;
  inTargetDoneCount?: number;
  inTargetWIPCount?: number;
  children: ReactElement[];
  withTargets?: boolean;
  onToggleCollapsedClick(): void;
  isCollapsed: boolean;
};

type TProps = TCardsGroupHeaderProps;

const CardsGroupHeader = (props: TProps) => {
  const hasValidTargets =
    typeof props.inTargetDoneCount == "number" &&
    typeof props.inTargetWIPCount == "number" &&
    !!props.withTargets;
  const boardsWithOutTargetSummary = `cards in total: ${props.children.length}\nno targets defined`;

  return (
    <div css={styles.boardContainer}>
      <div css={styles.boardHeading}>
        <ExpandIcon
          css={styles.expandIcon(props.isCollapsed)}
          onClick={() => props.onToggleCollapsedClick()}
        />
        <div css={styles.boardName}>{props.boardName}</div>
      </div>
      <div css={styles.boardBG(props.boardImage, props.boardColor)}></div>

      <ConditionalRender
        condition1={hasValidTargets}
        renderIf1True={
          <BoardTargetsSummary
            doneCount={props.inTargetDoneCount as number}
            wipCount={props.inTargetWIPCount as number}
            cardsCount={props.children.length}
          />
        }
      />
      <ConditionalRender
        condition1={!hasValidTargets}
        renderIf1True={
          <div
            title={boardsWithOutTargetSummary}
            css={[styles.boardHeading, styles.cursorInfo]}
          >
            <span css={[styles.target("none")]}>{props.children.length}</span>
          </div>
        }
      />
    </div>
  );
};

export default CardsGroupHeader;

const styles = {
  expandIcon: (isCollapsed) => css`
    z-index: 1;
    ${isCollapsed && `transform: rotate(-90deg)`};
    cursor: pointer;
  `,
  cursorInfo: css`
    cursor: help;
  `,
  boardContainer: css`
    display: flex;
    position: relative;
    padding: 0 8px;
    justify-content: space-between;
  `,
  target: (list: TTargetList) => css`
    color: ${list == "done"
      ? trelloColors["green-600"]
      : list == "wip"
      ? trelloColors["orange-600"]
      : "inherit"};
  `,
  boardHeading: css`
    font-weight: 600;
    z-index: 1;
    display: flex;
  `,
  boardName: css`
    /* display: flex; */
    margin-left: 8px;
  `,
  boardBG: (image: string | undefined, color: string) => css`
    background-image: ${image ? `url(${image});` : `none`};
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${color};
    background-size: cover;
    background-position: 50%;
    &:before {
      background: #fff;
      bottom: 0;
      content: "";
      left: 0;
      opacity: 0.7;
      position: absolute;
      right: 0;
      top: 0;
    }
  `,
};
